import i18n from '@/plugins/i18n';

const activeMqQueueGraphsConfig = [
  {
    metricName:
      'artemis_queue_message_added,artemis_queue_message_acknowledged',
    valueColumn: 'value',
    headers: [
      {
        label: i18n.global.t('mq.queue'),
        width: '60%',
        key: 'label',
        sortable: true,
        dataType: 'string',
      },
      {
        label: i18n.global.t('mq.added'),
        width: '20%',
        key: 'Added',
        infoIconReq: true,
        infoIconTooltipText: i18n.global.t('mq.totalAddedMessage'),
        sortable: true,
        dataType: 'number',
      },
      {
        label: i18n.global.t('mq.acknowledged'),
        width: '20%',
        key: 'Acknowledged',
        infoIconReq: true,
        infoIconTooltipText: i18n.global.t('mq.totalAcknowledgedMessage'),
        sortable: true,
        dataType: 'number',
      },
    ],
    isMultiMetric: true,
    formula: (value) => value.toFixed(3),
    legendProperty: 'total',
    title: i18n.global.t('mq.addedAndAcknowledged'),
    graphTitles: {
      x: i18n.global.t('mq.time'),
      y: i18n.global.t('mq.count'),
    },
  },
  {
    metricName: 'artemis_queue_message_killed,artemis_queue_message_expired',
    valueColumn: 'value',
    headers: [
      {
        label: i18n.global.t('mq.queue'),
        width: '60%',
        key: 'label',
        sortable: true,
        dataType: 'string',
      },
      {
        label: i18n.global.t('mq.expired'),
        width: '20%',
        key: 'Expired',
        infoIconReq: true,
        infoIconTooltipText: i18n.global.t('mq.totalExpiredMessage'),
        sortable: true,
        dataType: 'number',
      },
      {
        label: i18n.global.t('mq.killed'),
        width: '20%',
        key: 'Killed',
        infoIconReq: true,
        infoIconTooltipText: i18n.global.t('mq.totalKilledMessage'),
        sortable: true,
        dataType: 'number',
      },
    ],
    title: i18n.global.t('mq.expiredAndKilled'),
    isMultiMetric: true,
    formula: (value) => value.toFixed(3),
    legendProperty: 'total',
    graphTitles: {
      x: i18n.global.t('mq.time'),
      y: i18n.global.t('mq.count'),
    },
  },
  {
    metricName: 'artemis_queue_size',
    valueColumn: 'value',
    headers: [
      {
        label: i18n.global.t('mq.queue'),
        width: '60%',
        key: 'label',
        sortable: true,
        dataType: 'string',
      },
      {
        label: i18n.global.t('mq.avg'),
        width: '20%',
        key: 'avg',
        sortable: true,
        dataType: 'number',
      },
      {
        label: i18n.global.t('mq.max'),
        width: '20%',
        key: 'max',
        sortable: true,
        dataType: 'number',
      },
    ],
    title: i18n.global.t('mq.messageSize'),
    isMultiMetric: false,
    formula: (value) => (value / 1048576).toFixed(3),
    graphTitles: {
      x: i18n.global.t('mq.time'),
      y: i18n.global.t('mq.sizeInMB'),
    },
  },
  {
    metricName: 'artemis_queue_current_message',
    valueColumn: 'value',
    headers: [
      {
        label: i18n.global.t('mq.queue'),
        width: '80%',
        key: 'label',
        sortable: true,
        dataType: 'string',
      },
      {
        label: i18n.global.t('mq.avg'),
        width: '20%',
        key: 'avg',
        sortable: true,
        dataType: 'number',
      },
    ],
    title: i18n.global.t('mq.messageCount'),
    isMultiMetric: false,
    formula: (value) => value.toFixed(3),
    graphTitles: {
      x: i18n.global.t('mq.time'),
      y: i18n.global.t('mq.count'),
    },
  },
  {
    metricName: 'artemis_queue_delivering_count',
    valueColumn: 'value',
    headers: [
      {
        label: i18n.global.t('mq.queue'),
        width: '80%',
        key: 'label',
        sortable: true,
        dataType: 'string',
      },
      {
        label: i18n.global.t('mq.avg'),
        width: '20%',
        key: 'avg',
        sortable: true,
        dataType: 'number',
      },
    ],
    title: i18n.global.t('mq.dispatchCount'),
    isMultiMetric: false,
    formula: (value) => value.toFixed(3),
    graphTitles: {
      x: i18n.global.t('mq.time'),
      y: i18n.global.t('mq.count'),
    },
  },
];

export default activeMqQueueGraphsConfig;
